import { QueryClient } from "@tanstack/react-query";
import { useLoaderData } from "react-router-dom";

import { userQuery } from "#modules/users/infra/userQuery";
import { useUser } from "#modules/users/view/useUser";
import { PageLayout } from "#shared/layouts/PageLayout";
import { Alert } from "#shared/view/components/Alert";
import { CopyButton } from "#shared/view/components/CopyButton";
import { Group } from "#shared/view/components/Group";
import { Space } from "#shared/view/components/Space";
import { Button } from "#shared/view/designSystem/Button";
import { Data } from "#shared/view/designSystem/Data";

export const loader = (queryClient: QueryClient) => async () => {
  const data = await queryClient.fetchQuery(userQuery());

  return { data };
};

export const AccountPage = () => {
  const { data: initialUserData } = useLoaderData() as Awaited<
    ReturnType<ReturnType<typeof loader>>
  >;

  const { user } = useUser({ initialData: initialUserData });

  if (!user) {
    return (
      <Alert>{"Une erreur est survenue. Nous n'arrivons pas à récupérer vos informations"}</Alert>
    );
  }

  return (
    <PageLayout
      title="Mon compte"
      subtitle="Retrouvez les informations liées à votre compte personnel Fabera"
    >
      <Space h="md" />
      <Group>
        <Data label="Prénom" value={user.firstName} />
        <Data label="Nom" value={user.lastName} />
        <Data label="Email" value={user.email} />
      </Group>

      <Space h="md" />

      <Group>
        <Data label="Identifiant utilisateur" value={user.id} />
        <CopyButton value={user.id}>
          {({ copied, copy }) => (
            <Button color={copied ? "green" : ""} onClick={copy}>
              {copied ? "Identifiant copié" : "Copier l'identifiant"}
            </Button>
          )}
        </CopyButton>
      </Group>
    </PageLayout>
  );
};
